import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlService } from 'src/services/url-service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileRestService {
  constructor(
    private http: HttpClient,
    private urlService: UrlService
  ) {}

  downloadAudio(filename: string): Observable<Blob> {
    let name = filename.split('/').pop();
    let url = this.urlService.getFileDownloadURL()+name;
    return this.http.get(url, { responseType: 'blob' });
  }
}